module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Gc-Da-Ea.faa1af66.png";